(() => {
  if (window.whealthMemberLoginReady) return;
  window.whealthMemberLoginReady = true;
  let opener;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-whealth-login-open]');
    const dialog = document.getElementById('WhealthMemberLogin');
    if (!dialog) return;
    if (trigger) {
      opener = trigger;
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('whealth-member-login-open');
      return;
    }
    if (event.target.closest('[data-whealth-login-close]')) dialog.close();
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.id !== 'WhealthMemberLogin') return;
    document.documentElement.classList.remove('whealth-member-login-open');
    if (opener?.isConnected) opener.focus();
  }, true);
})();
